export const BUTTON_OUTLINED_HOVER_SHADOW_ALPHA = 0.4;
export const BUTTON_RIPPLE_OVERLAY_ALPHA = 0.9;

export const ICON_BUTTON_SPACING_LARGE_MULTIPLIER = 5.5;
export const ICON_BUTTON_SPACING_MEDIUM_MULTIPLIER = 4.5;
export const ICON_BUTTON_SPACING_SMALL_MULTIPLIER = 3.75;

export const CUSTOM_SHADOW_ALPHA_OUTLINE = 0.2;
export const CUSTOM_SHADOW_ALPHA_TABLE_BODY = 0.4;
export const CUSTOM_SHADOW_ALPHA_TABLE_ROW = 0.25;
export const CUSTOM_SHADOW_ALPHA_Z1_LIGHT = 0.08;

export const PALETTE_DIVIDER_DARK_ALPHA = 0.05;
export const PALETTE_TEXT_DISABLED_DARK_ALPHA = 0.1;
export const PALETTE_TEXT_PRIMARY_DARK_ALPHA = 0.87;
export const PALETTE_TEXT_SECONDARY_DARK_ALPHA = 0.45;

export const SWITCH_IOS_DISABLED_TRACK_OPACITY_DARK = 0.3;
export const SWITCH_IOS_DISABLED_TRACK_OPACITY_LIGHT = 0.7;
export const SWITCH_IOS_TRACK_RADIUS_PX = 26;
export const SWITCH_PILL_BORDER_RADIUS_DIVISOR = 2;
